import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import environment from 'environment';
import DTSearchView from '../../Common/DTSearchView/DTSearchView';
import { setLoadingUnique } from '../../../../actions';
import { getSimplrAccountIdOfSelectedTicket } from '../../../../extractFromState';
import { addEdgeToDecisionTreePath } from '../../../../actions/searchActions';
import { displayPopupMessageInformation } from '../../../tools/SearchPage/searchUtils';
import makeRequest from '../../../../api/makeRequest';
import { handleError } from '../../../../services/ErrorService/ErrorService';
import { getSelectedAccount, getSelectedPurchase } from '../../../../selectors/tools';
import SearchResults from './SearchResults/SearchResults';
import { setSelectedPurchase } from '../../../../actions/tools/DecisionTree/accountSearchActions';

const DTSearchAccountPurchaseHistory = () => {
  const dispatch = useDispatch();
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const { accountId } = useSelector(getSelectedAccount);
  const currentPurchase = useSelector(getSelectedPurchase);
  const setLoading = useCallback((loading) => dispatch(setLoadingUnique(loading, 'searchPage')), [dispatch]);

  const [searchResults, setSearchResults] = useState([]);
  const [selectedResult, setSelectedResult] = useState(currentPurchase);

  const handleSearchSubmit = useCallback(
    async (value) => {
      const itemNumber = value.trim();
      if (!itemNumber) {
        return displayPopupMessageInformation('Please enter a valid item number');
      }

      try {
        setLoading(true);
        const { purchaseHistory } = await makeRequest(
          `${environment.accountData.ACCOUNT_BASE_URL}/${accountId}/purchaseHistory`,
          { params: { simplrAccountId, itemNumber } }
        );

        if (isEmpty(purchaseHistory)) {
          dispatch(addEdgeToDecisionTreePath('no_search_results'));

          return;
        }

        setSearchResults(Array.isArray(purchaseHistory) ? purchaseHistory : [purchaseHistory]);
      } catch (error) {
        handleError({
          error,
          customMessage: 'Something went wrong when searching for account purchase history.',
          customFields: { accountId, simplrAccountId, itemNumber },
          showPopup: true,
        });
      } finally {
        setLoading(false);
      }
    },
    [dispatch, setLoading, simplrAccountId, accountId]
  );

  const handleNextButtonClick = () => {
    dispatch(setSelectedPurchase(selectedResult));
    dispatch(addEdgeToDecisionTreePath('history_found'));
  };

  return (
    <DTSearchView
      isNextButtonActive={!isEmpty(searchResults) && selectedResult}
      onNextButtonClick={handleNextButtonClick}
      handleSearchSubmit={handleSearchSubmit}
      placeholder={'Search by item number'}
      searchType={'searchByItemNumber'}
      defaultValue={''}
      dataToDisplay={searchResults}
      searchResultsComponent={
        <SearchResults results={searchResults} selectedResult={selectedResult} onChange={setSelectedResult} />
      }
      noDataMessageComponent={<></>}
    />
  );
};

export default DTSearchAccountPurchaseHistory;
